import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_fw-eb" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createBlock(_component_base_button, {
    theme: "lightOutline",
    weight: "thin",
    shape: "default",
    class: _normalizeClass($options.buttonClassList),
    "data-qa": `mini-wizard-item:${$props.name}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(['_line-clamp-2 _tal', { '_tc--accent': $props.isNew }]),
        "data-qa": "mini-wizard-item-label"
      }, [
        _createTextVNode(_toDisplayString($props.formattedAmount) + " ", 1 /* TEXT */),
        _createElementVNode("strong", _hoisted_1, _toDisplayString($props.name), 1 /* TEXT */)
      ], 2 /* CLASS */),
      ($props.canBeDeleted)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: "times-circle",
            class: "_tc--error _cur-p",
            onClick: _withModifiers($options.onRemoveItem, ["prevent","stop"]),
            "data-qa": "mini-wizard-item-btn:Remove"
          }, null, 8 /* PROPS */, ["onClick"]))
        : ($props.isLocked)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 1,
              text: $props.lockedReason
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "lock",
                  class: "_tc--lighter",
                  "data-qa": "mini-wizard-item-btn:Lock"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["text"]))
          : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "data-qa"]))
}